import { render, staticRenderFns } from "./Notification_Card.vue?vue&type=template&id=b0002e5a&scoped=true"
import script from "./Notification_Card.vue?vue&type=script&lang=js"
export * from "./Notification_Card.vue?vue&type=script&lang=js"
import style0 from "./Notification_Card.vue?vue&type=style&index=0&id=b0002e5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0002e5a",
  null
  
)

export default component.exports